import React from 'react';
import { ThemeProvider } from '@fluentui/react/lib/Theme';
import { darkBlueTheme } from '../AppGlobals';
import { CreateAccountStepper } from './account/CreateAccountStepper';

interface Props {
    currentStep?: number;
    maxStep?: number;
    onCloseMenu?: () => void;
}

export const CreateAccountMenu: React.FC<Props> = ({ currentStep = 1, maxStep = 1 }) => {

    const imagesRoot: string = process.env.REACT_APP_ZedXImagesRoot!;

    const stepNames: Record<number, string> = {
        1: "Welcome",
        2: "Your Details",
        3: "Edition",
        4: "Apps",
        5: "Summary",
        6: "Login"
    };

    const stepTitle = stepNames[currentStep] ?? "";

    return (

        <ThemeProvider theme={darkBlueTheme}>

            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

                {/* LOGO */}
                <div
                    style={{
                        width: '100%',
                        paddingBottom: '25px',
                        paddingLeft: '15px',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    <img
                        src={`${imagesRoot}/leftnav/LeftMenu-ZedXMainMenu.png`}
                        alt="ZedX"
                        style={{ maxWidth: '100%', height: 'auto' }}
                    />
                </div>

                {/* STEP INFO BOX */}
                <div
                    style={{
                        backgroundColor: "#1A619F",
                        color: "white",
                        padding: "10px 15px",
                        margin: "5px 10px 15px",
                        borderRadius: "4px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "2px"
                    }}
                >
                    <div>Create Account</div>
                    <div>Step: {stepTitle}</div>
                </div>

                {/* WIZARD STEPPER */}
                <CreateAccountStepper currentStep={currentStep} maxStep={maxStep} />

            </div>

        </ThemeProvider>

    );
};